import { Routes } from "@angular/router";

export const BankRoutes: Routes = [
	{
		path: "",
		loadComponent: () =>
			import("@/app/domains/erp/banking/pages/bank-management/bank-management.page").then(
				(m) => m.BankManagementPage
			),
	},
	{
		path: "bank-cash-deposit",
		loadComponent: () =>
			import(
				"@/app/domains/erp/banking/pages/bank-cash-deposit/bank-cash-deposit.page"
			).then((m) => m.BankCashDepositPage),
	},
	{
		path: "bank-account",
		loadComponent: () =>
			import("@/app/domains/erp/banking/pages/bank-account/bank-account.page").then(
				(m) => m.BankAccountPage
			),
	},
	{
		path: "bank-account-view",
		loadComponent: () =>
			import(
				"@/app/domains/erp/banking/pages/bank-account-view/bank-account-view.page"
			).then((m) => m.BankAccountViewPage),
	},
	{
		path: "**",
		redirectTo: "",
		pathMatch: "full",
	},
];
